import * as React from 'react';
import {CreateBreadcrumb} from "./Data";
import Lang from "../../common/lang/Lang";
import API from './../../common/AxoisClient';
import {EmailValues, SearchValues} from "../../model/Email";
import * as _ from 'lodash';
import {RouteComponentProps} from "react-router";
import {EmailValidations} from "./Validation";
import {CreateLayout} from "../../layout/CreateLayout";
import {UserModel} from "../../model";
import { Select, SwitchLoader} from "../../common";
import {LoaderType} from "../../common";
import {CommonSubmitButton} from "../../common";
import {SummerNote} from "../../common/form/Summernotes";
import { ClubService } from '../../services';


declare var window: any;

interface IState {
  form: {

    registered_interpreters: string,
    subject: string,
    message: string,
    attachment?: string,
    user_email?: string,
    userIds: Array<any>,
    translator: number,
    customer: number,
    language_from?: number,
    language_to?: number,
    user_type?: number
  };

  searchVal: {
    query: string,
    userStatus: string,
    user_type: number,
  };

  allUsers: Array<any>;
  id: number;
  user_type: number;
  userIds: Array<any>;

  uploadDocument?: File;
  uploadFileName?: string
  languagecodes: Array<any>;
  typeUsers?: number;
  userStatus?: string;
  is_allt: boolean;
  is_allc: boolean;
  all_selected: boolean;


  selectallIds: Array<any>;
  usermessage: boolean;
  newsletter_email: string;
  keywords: Array<string>;
  insertedKeywords: Array<string>;

  clubs: Array<any>;
  teams: Array<any>;
  selectedClub?: string;
  selectedTeam?: string;
  allUsersBackup: Array<any>;

}

export class EmailCreate extends React.Component<RouteComponentProps, IState> {
  state: IState;

  constructor(props: any) {
    super(props);


    this.state = {
      form: EmailValues(),
      searchVal: SearchValues,
      id: props.match.params.id,
      allUsers: [],
      allUsersBackup: [],
      user_type: 0,

      typeUsers: 0,
      userIds: [],

      uploadDocument: null,
      uploadFileName: '',
      languagecodes: [],
      userStatus: '',
      selectallIds: [],
      is_allt: false,
      is_allc: false,
      all_selected: false,
      usermessage: false,
      newsletter_email: '',
      keywords: [],
      insertedKeywords: [],
      clubs: [],
      teams: [],
      selectedClub: '',
      selectedTeam: '',

    }
    EmailValidations();
    this.handleEditorChange = this.handleEditorChange.bind(this);

  }

  selectionRange: Range | null = null;

  saveSelection = () => {
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      this.selectionRange = sel.getRangeAt(0);
    }
  };

  insertKeywordAtCursor = (keyword: string) => {
    const editor = document.querySelector(".note-editable") as HTMLElement;
    if (!editor) return;
    let range = this.selectionRange;
    if (!range) {
      range = document.createRange();
      range.selectNodeContents(editor);
      range.collapse(editor.innerText.trim() === "");
    }
    const node = document.createTextNode(`{{${keyword}}}`);
    range.insertNode(node);
    range.setStartAfter(node);
    range.setEndAfter(node);
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
    this.selectionRange = range;
  };

  removeKeywordFromEditor = (element: HTMLElement, regex: RegExp) => {
    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = node.nodeValue?.replace(regex, "") ?? node.nodeValue;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        this.removeKeywordFromEditor(node as HTMLElement, regex);
      }
    });
  };

  toggleKeyword = (keyword: string) => {
    const editor = document.querySelector(".note-editable") as HTMLElement;
    if (!editor) return;
    const regex = new RegExp(`\\{\\{\\s*${keyword}\\s*\\}\\}`, "g");
    const isInserted = this.state.insertedKeywords.indexOf(keyword) > -1;

    if (isInserted) {
      this.removeKeywordFromEditor(editor, regex);
      this.setState({
        insertedKeywords: this.state.insertedKeywords.filter((k) => k !== keyword),
        form: {...this.state.form, message: editor.innerHTML},
      });
    } else {
      this.insertKeywordAtCursor(keyword);
      this.setState({
        insertedKeywords: [...this.state.insertedKeywords, keyword],
        form: {...this.state.form, message: editor.innerHTML},
      });
    }
  };


  getData = () => {
    const userType = this.state.user_type;
    if (![2, 6].includes(userType)) return;
    let searchChar = $.trim(this.state.searchVal.query);
    let strLength = searchChar.length;
    const params: any = {
      ...this.state.searchVal
    };

    if (this.state.selectedClub) {
      params.club_id = this.state.selectedClub;
    }

    if (this.state.selectedTeam) {
      params.team_id = this.state.selectedTeam;
    }

    if (strLength >= 3 || this.state.selectedClub || this.state.selectedTeam) {
      API.get(`email/get-allusers`, {params}).then(res => {

        if (res.data) {
          this.setState({
            allUsers: res.data,
            allUsersBackup: res.data
          });
        }
      });

    }

  }

  componentDidMount() {
    this.initData();
    this.getNewsletterEmail();
  }

  initData = async () => {
    const clubList = await ClubService.clubsList();

    const normalizedClubs = clubList.map((c: any) => ({
      value: c.value ?? c.id,
      label: c.label ?? c.name,
      teams: c.teams || []
    }));

    this.setState({
      clubs: [{ label: "Select Club", value: "", teams: [] }, ...normalizedClubs],
      teams: []
    });
  };

  getNewsletterEmail = () => {
    API.get("email/getnewsletter-email").then((res: any) => {
      this.setState({
        newsletter_email: res.data[0].setting_value,
      });
    })

    API.get("email/newsletter-keywords").then((res: any) => {
      this.setState({keywords: res.data || []});
    })

    const editableDiv = document.querySelector(".note-editable");
    if (editableDiv) {
      (["focus", "click", "keyup", "mouseup"] as (keyof HTMLElementEventMap)[]).forEach((e) =>
        editableDiv.addEventListener(e, this.saveSelection)
      );
    }
  }

  componentWillUnmount() {
    const editableDiv = document.querySelector(".note-editable");
    if (editableDiv) {
      (["focus", "click", "keyup", "mouseup"] as (keyof HTMLElementEventMap)[]).forEach((e) =>
        editableDiv.removeEventListener(e, this.saveSelection)
      );
    }
  }

  onChangeSearch = (event: React.ChangeEvent<any>) => {
    const value = event.target.value;
    if (this.state.user_type == 6) {

      if (value === '') {
        this.setState({
          usermessage: false,
          searchVal: { ...this.state.searchVal, query: value },
          allUsers: this.state.allUsersBackup
        });
      } else {
        const filteredUsers = this.state.allUsersBackup.filter((user: any) =>
          (user.first_name?.toLowerCase().includes(value.toLowerCase()) ||
          user.last_name?.toLowerCase().includes(value.toLowerCase()))
        );

        this.setState({
          usermessage: true,
          searchVal: { ...this.state.searchVal, query: value },
          allUsers: filteredUsers
        });
      }

    } else {
      if (value === '') {
        this.setState({
          usermessage: false,
          searchVal: { ...this.state.searchVal, query: value },
          allUsers: []
        });
      } else {
        this.setState({
          usermessage: true,
          searchVal: { ...this.state.searchVal, query: value },
        }, this.getData);
      }
    }
  };

  handleEditorChange(message: any, editor: any) {
    const detectedKeywords = this.state.keywords.filter((keyword) => {
      const regex = new RegExp(`\\{\\{\\s*${keyword}\\s*\\}\\}`, "g");
      return regex.test(message);
    });

    if (message !== '') {
      const cleanMsg = message.replace(/<br>|<div><\/div>|<p><br><\/p>/g, '').trim();
      if (cleanMsg !== '') {
        $('.tox-tinymce').css('border-color', '#ccc');
        $("#errorEditor").html(" ");
        this.setState({form: {...this.state.form, message: message}, insertedKeywords: detectedKeywords});
      } else {
        $('.tox-tinymce').css('border-color', '#fd397a');
        $("#errorEditor").html("This field is required.");
        //this.setState({insertedKeywords: detectedKeywords});
        this.setState({
          insertedKeywords: detectedKeywords,
          form: { ...this.state.form, message: '' }
        });
      }
    }
  }


  onChangeAllSelect = (event: React.ChangeEvent<any>) => {
    const targetCheck = event.target;
    const value = targetCheck.value;
    const name = targetCheck.name;

    let selectIds = [];
    this.state.allUsers.map((item: UserModel, index: number) => {
      selectIds.push(item.id);
    })

    if (event.target.checked === true) {
      this.setState({
        all_selected: true,
        form: {...this.state.form, userIds: selectIds},
        selectallIds: selectIds
      });

    } else {

      this.setState({
        all_selected: false,
        form: {...this.state.form, userIds: []},
        selectallIds: []
      });
    }
  }

  handleChange = async (event: React.ChangeEvent<HTMLElement>) => {
    const target: any = event.target;
    let value = target.value;
    const name = target.name;

    if (name === 'userIds') {


      if (target.checked === true) {

        await this.setState(prevState => ({selectallIds: [...prevState.selectallIds, Number(value)]}));
      } else {

        await this.setState({
          selectallIds: this.state.selectallIds.filter(function (item: number) {
            return item !== Number(value)
          })
        });
      }


      let userIds = this.state.form.userIds;

      if (_.indexOf(userIds, value) > -1) {
        userIds = _.pull(userIds, value);
      } else {
        userIds = _.concat(userIds, value);
      }

      value = _.compact(userIds);

    }


    if (name === 'status') {
      this.setState({
        searchVal: {...this.state.searchVal, userStatus: value},
      }, this.getData);
    }

    if (name === 'club') {
      const selectedClub = this.state.clubs.find(
        (club: any) => String(club.value) === String(value)
      );

      const teams = (selectedClub?.teams ?? []).map((t: any) => ({
        value: t.id ?? t.value,
        label: t.name ?? t.label
      }));

      this.setState({
        selectedClub: value,
        selectedTeam: '',
        teams: teams
      }, () => {
        if ([2,6].includes(Number(this.state.user_type))) {
          this.getData();
        }
    });
    }

    if (name === 'team') {
      this.setState({
        selectedTeam: value,
        searchVal: {
          ...this.state.searchVal,
          query: ''
        },
        allUsers: [],
        selectallIds: []
     }, () => {
        const userType = Number(this.state.user_type);
        if ([2, 6].includes(userType)) {
          this.getData();
        }
    });
    }

    if (name !== 'translator')
      this.setState({form: {...this.state.form, [name]: value}});

  }


  handleCheckboxChange = (event: React.ChangeEvent<any>) => {
  const targetCheck = event.target;
  const checkValue = Number(targetCheck.value);
  const name = targetCheck.name;
  $("#errorEditor").html("");
  $('.tox-tinymce').css('border-color', '#ccc');
  const baseReset = {
    user_type: checkValue,
    form: {
      ...this.state.form,
      user_type: checkValue,
      userIds: [],
      registered_interpreters: '',
      user_email: '',
      language_from: 0,
      language_to: 0,
      translator: checkValue == 1 ? 2 : 1,
      customer: checkValue == 1 ? 1 : this.state.form.customer,
    },
    searchVal: {
      ...SearchValues,
      user_type: checkValue,
      query: "",
      userStatus: "",
    },
    selectedClub: "",
    selectedTeam: "",
    teams: [],   
    allUsers: [],
    allUsersBackup: [],
    selectallIds: [],
    is_allt: false,
    is_allc: false,
    all_selected: false,
    usermessage: false
  };

  if (event.target.checked === true) {
    this.setState({
      ...baseReset,
      [name]: checkValue,
      is_allt: checkValue == 1,
      is_allc: checkValue == 1,
    } as any);
  } else {
    this.setState({
      ...baseReset,
      [name]: 0,
    } as any);
  }
  };

  handleUpload = (e) => {
    const file = e.target.files[0];
    this.setState({
      uploadFileName: file?.name
    });
    let formData = new FormData();
    formData.append('attachment', e.target.files[0]);
    API.post('email/uploadDocument', formData).then((res) => {
      this.setState({form: {...this.state.form, attachment: res.data[0]}});

    });
  }

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    console.log(this.state.form);
    event.preventDefault();
    SwitchLoader(LoaderType.BUTTON);
    if ($("#customer_form").valid()) {
      API.post('email/email', this.state.form).then((res) => {
        this.props.history.push(`/email/email`)
      })
    }
  }

  render() {
  const hideUserStatus = [4, 5, 6].includes(Number(this.state.user_type));
    return (
      <CreateLayout breadcrumb={CreateBreadcrumb} title={'email'}>

        <form className="kt-form" id={'customer_form'} onSubmit={this.handleSubmit}>
          <div className="kt-portlet__body">
            <div className={'row'}>
              <div className={"col-md-12 col-lg-12"}>
                <div className={'row'}>
                  <div className={"col-md-6 col-lg-6"}>

                    <div className="form-group">

                      <label className="d-block">{Lang.select_users} </label>
                      <label className="kt-checkbox">
                        <input type="radio" value={1} onChange={this.handleCheckboxChange}
                               name="user_type"/>{Lang.all_users} <span></span>&nbsp;
                        <span></span>
                      </label>
                      <label className="kt-checkbox">
                        <input type="radio" value={2} id="is_user_type" onChange={this.handleCheckboxChange}
                               checked={this.state.user_type == 2}
                               name="user_type"/>{Lang.specific_users} <span></span>&nbsp;
                        <span></span>
                      </label>
                      <label className="kt-checkbox">
                        <input type="radio" value={3} onChange={this.handleCheckboxChange}
                               name="user_type"/>{Lang.custom_users} <span></span>&nbsp;
                        <span></span>
                      </label>
                       <label className="kt-checkbox">
                        <input type="radio" value={4} onChange={this.handleCheckboxChange}
                               name="user_type"/>{Lang.club} <span></span>&nbsp;
                        <span></span>
                      </label>
                       <label className="kt-checkbox">
                        <input type="radio" value={5} onChange={this.handleCheckboxChange}
                               name="user_type"/>{Lang.team} <span></span>&nbsp;
                        <span></span>
                      </label>
                       <label className="kt-checkbox">
                        <input type="radio" value={6} onChange={this.handleCheckboxChange}
                               name="user_type" />{Lang.player} <span></span>&nbsp;
                        <span></span>
                      </label>

                    </div>


                    {this.state.user_type == 3 &&
                    <div className="form-group">
                      <label>{Lang.email}</label>
                      <input type={'text'} onChange={this.handleChange} name="user_email" className="form-control"/>
                    </div>
                    }
                    {!hideUserStatus && (
                    <div className="form-group">
                      <label>{Lang.user_status} <span className={'required'}></span></label>
                      <select className={'form-control '} onChange={this.handleChange} name="status">
                        <option defaultValue=''>Select option</option>
                        <option value='1'>Active</option>
                        <option value='2'>Inactive</option>
                      </select>
                    </div>
                    )}

                    <div className="form-group">
                      <label>{Lang.from} <span className={'required'}>*</span></label>
                      <input type={'text'} onChange={this.handleChange} name="from" value={this.state.newsletter_email}
                             className="form-control"/>
                    </div>


                    <div className="form-group">
                      <label>{Lang.subject} <span className={'required'}>*</span></label>
                      <input type={'text'} onChange={this.handleChange} name="subject" className="form-control"/>
                    </div>


                    <div className="form-group">
                      <label>{Lang.message_content}<span className={'required'}>*</span></label>

                      {this.state.user_type == 3 ?
                        <span className="form-text text-muted d-block" style={{marginBottom: 8}}>Keywords are not available when sending to custom email addresses.</span>
                        :
                        this.state.keywords.length > 0 &&
                        <div style={{marginBottom: 8}}>
                          {this.state.keywords.map((keyword: string) => (
                            <button type="button" key={keyword}
                                    className={`btn btn-sm ${this.state.insertedKeywords.indexOf(keyword) > -1 ? 'btn-primary' : 'btn-secondary'}`}
                                    style={{marginRight: 6, marginBottom: 6}}
                                    onClick={() => this.toggleKeyword(keyword)}>
                              {`{{${keyword}}}`}
                            </button>
                          ))}
                        </div>
                      }

                      <SummerNote id='message' value={this.state.form.message} onEditorChange={this.handleEditorChange}/>
                      <span id='errorEditor' style={{color: '#fd397a'}}/>
                      {/* <input type={'text'}  onChange={this.handleChange} name="message" className="form-control"  /> */}

                    </div>


                    <div className="form-group">
                      <label>{Lang.mail_attchment} </label>
                      <div className="custom-file">
                        <input type={'file'} onChange={this.handleUpload} name="attachment"
                               className="custom-file-input"/>
                        <label className="custom-file-label" htmlFor="customFile">{this.state.uploadFileName || Lang.choose_file}</label>
                      </div>
                    </div>


                  </div>
                  <div className={"col-md-6 col-lg-6"}>
                    {this.state.user_type == 4 || this.state.user_type == 5 || this.state.user_type == 6 ? (
                      <div className='kt-mb-10'>
                        <Select className="form-control" name="club" value={this.state.selectedClub} onChange={this.handleChange}>
                          {this.state.clubs.map((c: any) => (
                            <option key={c.value} value={c.value}>{c.label}</option>
                          ))}
                        </Select>
                      </div>
                    ) : null}

                    {this.state.user_type == 5 || this.state.user_type == 6 ? (
                      <div className='kt-mb-10'>
                        <Select className="form-control" name="team" value={this.state.selectedTeam} onChange={this.handleChange}>
                          <option value="">Select Team</option>
                          {this.state.teams.map((t: any) => (
                            <option key={t.value} value={t.value}>
                              {t.label}
                            </option>
                          ))}
                        </Select>
                      </div>
                    ) : null}

                    {(this.state.user_type == 2 || this.state.user_type == 6) && (

                    <div className="form-group">
                      <input type="text" placeholder="Please type minimum 3 characters for search"
                             value={this.state.searchVal.query} onChange={this.onChangeSearch}
                             className="form-control"/>
                      <div className="kt-checkbox-inline">
                        {this.state.allUsers.length > 0 &&
                        <label className="kt-checkbox"><input type="Checkbox" onChange={this.onChangeAllSelect}
                                                              name={'select_all'} value={'all'}/>Select all<span></span></label>}

                        {this.state.allUsers.length === 0 && this.state.usermessage === true &&
                        <div className="alert alert-outline-warning fade show">Users not found</div>
                        }
                        {this.state.allUsers.length > 0 && this.state.allUsers.map((item: UserModel, index: number) => {
                          return <label key={item.id} className="kt-checkbox">
                            <input type="Checkbox" onChange={this.handleChange} name={'userIds'} value={item.id}
                                   checked={_.indexOf(this.state.selectallIds, item.id) > -1}/>{item.name}
                            <span></span>
                          </label>
                        })}

                      </div>
                    </div>
                   )}

                  </div>
                </div>
              </div>
            </div>
          </div>
          <CommonSubmitButton/>
        </form>
      </CreateLayout>

    )
  }
}